<div class="register-container">
  <div>
    <h1 class="register-container__title">Sign Up</h1>
    <p class="register-container__desc">Create account</p>
    <form
      [formGroup]="form"
      (ngSubmit)="register()"
      fxLayout="column"
      fxLayoutAlign="center"
    >
      <aran-input
        type="text"
        placeholder="Enter your email"
        label="Email"
        formControlName="email"
        [readonly]="true"
        [errorMessages]="{
          required: errorMessages.required('Email'),
          email: errorMessages.email
        }"
      ></aran-input>

      <app-input-psw-criteria
        type="password"
        placeholder="Enter your password"
        label="Password"
        formControlName="password"
        [obscure]="true"
        [criteriaList]="criteriaList"
        [errorMessages]="{
          required: errorMessages.required('Password'),
          minlength: errorMessages.minlength(8),
          ascii: errorMessages.ascii,
          weak: errorMessages.weak
        }"
        (enterPressed)="onEnterPressed()"
      >
      </app-input-psw-criteria>

      <aran-input
        type="password"
        placeholder="Retype your password"
        label="Confirm Password"
        formControlName="confirmPassword"
        [obscure]="true"
        [errorMessages]="{
          required: errorMessages.required('Confirm Password'),
          passwordMismatch: errorMessages.notMatch
        }"
        (enterPressed)="onEnterPressed()"
      >
      </aran-input>

      <div class="mt-5">
        <aran-button
          class="w-full"
          [type]="'submit'"
          [name]="'Register'"
          [disabled]="!form.valid"
        ></aran-button>
      </div>
    </form>
  </div>
</div>
